import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { Query } from './Query';
import { IQueryOptionsObject } from '../models/query/options';

export class ObjectQuery extends BaseQuery<IQueryOptionsObject> {
	getOptions(): IQueryOptionsObject {
		const { fields, options = {} } = this.queryOptions;
		return {
			fields,
			...(options.object || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { fields } = this.queryOptions;
		const response: object = {};
		for (const field of fields) {
			const { name, query } = field;
			if (query) {
				const valueQuery = new Query(query);
				const value = valueQuery.execute(executionOptions);
				response[name] = value;
			}
		}
		return response as any as T;
	}
}